import Vue from "vue";
import Router from "vue-router";
import parametricSearch from "../views/parametric-search/ParametricSearch.vue";
import productComparison from "../views/parametric-search/ProductComparison";
import recommendedDriver from "../views/parametric-search/RecommendedDriver";
import demoBoardView from "../views/parametric-search/DemoBoardView";

Vue.use(Router);

export default new Router({
    // mode: "",
    // base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "parametric-search-page",
            component: parametricSearch,
        },
        {
            path: "/compare",
            name: "comparison-page",
            component: productComparison,
        },
        {
            path: "/recommended-driver",
            name: "recommended-driver-page",
            component: recommendedDriver
        },
        {
            path: "/demo-board",
            name: "demo-board-page",
            component: demoBoardView
        }
    ]
});
